import TextInput from '../../../components/textInput/TextInput';
import { BasketService } from '../../../services/basket/BasketService';
import { IDeliveryData } from '../../../services/basket/IDeliveryData';
import * as style from './style.css';
import { EventTypes } from '../../../services/eventEmmiter/EventTypes';
import Emitter from '../../../services/eventEmmiter/EventEmmiter';
import React = require('react');

interface IProps {
    basketService: BasketService;

}

interface IState {
    deliveryData: IDeliveryData;
}

export default class OrderDeliveryForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            deliveryData: {
                name: '',
                street: '',
                zipCode: '',
                city: '',
                email: '',
                phone: '',
                errors: {}
            }

        };
    }

    basketService = BasketService.Instance();

    componentDidMount() {
        this.getDeliveryData();
    }

    render() {
        const delivery = this.state.deliveryData;
        return (
            < div className={style.userForm}>
                <div className={style.input}>
                    <TextInput
                        key={1}
                        value={delivery.name}
                        onChange={(s: string) => this.setDeliveryState('name', s)}
                        onKeyDown={() => { }}

                        errors={this.state.deliveryData.errors.name}
                        placeholder="Imię/nazwisko, nazwa firmy*" />
                </div>
                <div className={style.input}>

                    <TextInput
                        key={2}
                        value={delivery.street}
                        onChange={(s: string) => this.setDeliveryState('street', s)}
                        onKeyDown={() => { }}

                        errors={this.state.deliveryData.errors.street}
                        placeholder="ulica,nr domu*" />
                </div>
                <div className={style.input}>

                    <TextInput
                        key={2}
                        value={delivery.zipCode}
                        onChange={(s: string) => this.setDeliveryState('zipCode', s)}
                        onKeyDown={() => { }}

                        errors={this.state.deliveryData.errors.zipCode}
                        placeholder="kod*" />
                </div>
                <div className={style.input}>

                    <TextInput
                        key={2}
                        value={delivery.city}
                        onChange={(s: string) => this.setDeliveryState('city', s)}
                        errors={this.state.deliveryData.errors.city}

                        onKeyDown={() => { }}
                        placeholder="miasto*" />
                </div>
                <div className={style.input}>
                    <TextInput
                        key={2}
                        value={delivery.email}
                        onChange={(s: string) => this.setDeliveryState('email', s)}
                        onKeyDown={() => { }}

                        errors={this.state.deliveryData.errors.email}
                        placeholder="email*" />
                </div>
                <div className={style.input}>
                    <TextInput
                        key={2}
                        value={delivery.phone}
                        onChange={(s: string) => this.setDeliveryState('phone', s)}
                        errors={this.state.deliveryData.errors.phone}
                        onKeyDown={() => { }}

                        placeholder="telefon (9 cyfr)*" />
                </div>
            </div>
        );
    }

    getDeliveryData() {
        this.basketService.getDeliveryData((d) => this.onDadatExists(d));
    }

    onDadatExists(d: any) {
        d.errors = {};
        this.setState({ deliveryData: d });
    }

    onOrderFormClick(): void {
        this.basketService.setDeliveryData(this.state.deliveryData, () => this.onSuccess(), (e) => this.onErrors(e));
    }

    onSuccess(): void {
        Emitter.emit(EventTypes.UserData, null);
        const data = this.state.deliveryData;
        data.errors = {};
        this.setState({ deliveryData: data });
    }

    onErrors(e: any): void {
        Emitter.emit(EventTypes.UserData, null);
        const data = this.state.deliveryData;
        data.errors = e;
        this.setState({ deliveryData: data });
    }

    setDeliveryState(propName: string, value: string): void {
        const data = this.state.deliveryData;
        data[propName] = value;
        this.setState({ deliveryData: data });
        this.onOrderFormClick();
    }
}
